import { combineReducers } from 'redux';
import posts from './posts';
import authReducer from './auth';
import profileReducer from './profile';
import socketsReducer from './sockets';
import notificationsReducer from './notifications';
import dynamicUIReducer from './dynamicUI';
import chatUIReducer from './chatUI';
import chatReducer from './chat';

export default combineReducers({
    posts,
    authReducer,
    profileReducer,
    socketsReducer,
    notificationsReducer,
    dynamicUIReducer,
    chatUIReducer,
    chatReducer
});